import BaseModal from "../BaseModal/BaseModal";
import ScoreProgress from "../../component/ScoreProgress";
import Grading, { getGrade } from "../../variables/Grading";
import AnswerDropDown, { AnswerEmptyDropDown } from "../../component/AnswerDropDown";
import SentenceCefr from "../../../Tools/CrfChecker/Components/SentenceCefr";
import { useState } from "react";
import ScoreProgressCard from "../../component/ScoreProgressCard";


function HeadingBlog({ title, paragraph }) {

    if (!paragraph) return null
    return (
        <div className={"flex flex-col items-start w-full gap-3 "}>
            <h1 className={"text-xl font-bold  text-gray-700  "}>{title} </h1>
            <p className={"text-sm font-normal  text-gray-700  "}>
                {paragraph}
            </p>
        </div>
    )
}

function AiSuggestion({ suggestions }) {

    if (!suggestions) return null

    return (<div className={"flex flex-col gap-3 "}>
        <h1 className={"text-xl font-bold  text-gray-700  "}>AI Suggestion </h1>
        {
            Object.keys(suggestions).map((item, i) => {
                return (
                    <div>
                        <h1 className={"font-semibold my-[1px] py-[1px] opacity-40"}>
                            {item}
                        </h1>
                        <ul className={"list-decimal ml-6"}>
                            {
                                suggestions[item].map((suggestion, i) => {
                                    return (
                                        <li>
                                            {suggestion}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                )
            })
        }
    </div>
    )
}


function WordGrading({ wordsGrade }) {

    if (!wordsGrade) return null
    return (
        <div className={"flex flex-col gap-3 "}>
            <h1 className={"text-xl font-bold  text-gray-700  "}>AI Recognition </h1>
            <div className={"flex flex-row mt-2 items-center gap-2"}>
                {Grading.map((item, i) => {
                    return (<div className={"flex justify-center gap-1 items-center"}>
                        <div
                            className={"w-4 h-4 rounded-full"}
                            style={{
                                backgroundColor: item.color
                            }}
                        />
                        <p>
                            {item.type}
                        </p>
                    </div>)
                })}
            </div>
            <div className={"flex flex-row mt-2 items-center gap-1"}>
                {Object.keys(wordsGrade).map((item, i) => {

                    return (
                        <>
                            <div className={"first:hidden"}>
                                {"/"}
                            </div>
                            <p
                                style={{
                                    color: getGrade(wordsGrade[item]).color
                                }}
                                className={"cursor-pointer"}
                                title={getGrade(wordsGrade[item]).type}
                            >
                                {item}
                            </p>
                        </>
                    )
                })}

            </div>
        </div>

    )
}


function CorrectSelected({ correctSelected, correct }) {

    if (!correctSelected || !correct) return null

    return (
        <div className={"flex flex-col gap-3 "}>
            <h1 className={"text-xl font-bold  text-gray-700  "}>Correct Selected</h1>
            <p>
                {
                    correct.map((item, i) => {

                        return (
                            <span
                                className={"mr-1"}
                                style={{
                                    color: correctSelected.includes(item) ? "green" : "red"
                                }}
                            >
                                {item},
                            </span>
                        )
                    })
                }
            </p>

        </div>
    )
}


export default function GenericQuestionModal({ className, showModal, setShowModal, result, ...props }) {
    const [showResponseNumber, setShowResponseNumber] = useState(0)

    // Determine total responses based on keys
    let totalResponse = 1;
    if (result?.response3) totalResponse = 3;
    else if (result?.response2) totalResponse = 2;

    let response = result;
    if (showResponseNumber === 1) response = result?.response2;
    if (showResponseNumber === 2) response = result?.response3;

    return (<BaseModal
        title={"AI Score"}
        isBoxOpen={showModal}
        setIsBoxOpen={setShowModal}
    >

        <div className={"flex flex-col  lg:px-12 gap-8"}>
            {totalResponse > 1 &&
                <div className={"flex flex-col justify-center items-center"}>
                    <div className={"flex flex-row gap-3"}>
                        <div
                            style={{
                                borderBottom: showResponseNumber === 0 ? "2px solid black" : "none"
                            }}
                            onClick={() => setShowResponseNumber(0)}
                            className={"border-b-[1px] cursor-pointer pb-3 text-center w-[150px]"}>
                            Result 1
                        </div>
                        <div
                            style={{
                                borderBottom: showResponseNumber === 1 ? "2px solid black" : "none"
                            }}
                            onClick={() => setShowResponseNumber(1)}

                            className={"border-b-[1px] cursor-pointer pb-3 text-center w-[150px]"}>
                            Result 2
                        </div>
                        {totalResponse >= 3 && (
                            <div
                                style={{
                                    borderBottom: showResponseNumber === 2 ? "2px solid black" : "none"
                                }}
                                onClick={() => setShowResponseNumber(2)}

                                className={"border-b-[1px] cursor-pointer pb-3 text-center w-[150px]"}>
                                Result 3
                            </div>
                        )}
                    </div>

                </div>
            }
            <div className={" "}>
                <h1 className={"text-2xl font-bold text-center text-gray-700 mb-10 "}>Score: {response?.overAllScore}/{response?.totalScore || 160} </h1>
                <div
                    className={"flex flex-row lg:w-[70%] mx-auto flex-wrap gap-[30px] lg:gap-[60px] justify-center items-center my-4  lg:px-10"}>
                    <ScoreProgress value={response?.overAllScore}
                        total={response?.totalScore || 160}

                        color={"#0C99FF"}
                        title={"Overall Score"} />
                    <ScoreProgress value={response?.accuracy}
                        total={response?.totalScore || 160}
                        color={"#00B828"}
                        title={"Accuracy"} />
                    <ScoreProgress value={response?.completion}
                        total={response?.totalScore || 160}
                        color={"#bf0010"}
                        title={"Completion"} />
                    <ScoreProgress value={response?.grammaticalAccuracy}
                        total={response?.totalScore || 160}
                        color={"#00B828"}
                        title={"Grammatical accuracy"} />
                    <ScoreProgress value={response?.grammaticalComplexity}
                        total={response?.totalScore || 160}
                        color={"#03EFFE"}
                        title={"Grammatical complexity"} />
                    <ScoreProgress value={response?.lexicalSophistication}
                        total={response?.totalScore || 160}
                        color={"#FE0303"}
                        title={"Lexical sophistication"} />
                    <ScoreProgress value={response?.relevancy}
                        total={response?.totalScore || 160}
                        color={"#6703fe"}
                        title={"Task relevance"} />
                    <ScoreProgress value={response?.fluency}
                        total={response?.totalScore || 160}
                        color={"#50C0FF"}
                        title={"Fluency"} />
                    <ScoreProgress value={response?.lexicalDiversity}
                        total={response?.totalScore || 160}
                        color={"#D250FF"}
                        title={"Lexical diversity"} />
                    <ScoreProgress value={response?.acousticFeature}
                        total={response?.totalScore || 160}
                        color={"#fffc50"}
                        title={"Acoustic Feature"} />


                </div>
                <div className={"grid pt-12 grid-cols-1 lg:grid-cols-3 gap-8"}>
                    <ScoreProgressCard value={response?.grammaticalAccuracy}
                        total={response?.totalScore || 160}
                        color={"#00B828"}
                        title={"Grammatical accuracy"}
                        suggestions={response?.grammaticalAccuracySuggestions || []}
                    />
                    <ScoreProgressCard value={response?.grammaticalComplexity}
                        total={response?.totalScore || 160}
                        color={"#03EFFE"}
                        title={"Grammatical complexity"}
                        suggestions={response?.grammaticalComplexitySuggestions || []}
                    />
                    <ScoreProgressCard value={response?.lexicalSophistication}
                        total={response?.totalScore || 160}
                        color={"#FE0303"}
                        suggestions={response?.lexicalSophisticationSuggestions || []}
                        title={"Lexical sophistication"} />
                    <ScoreProgressCard value={response?.lexicalDiversity}
                        suggestions={response?.lexicalDiversitySuggestions || []}
                        total={response?.totalScore || 160}
                        color={"#D250FF"}
                        title={"Lexical diversity"} />
                    <ScoreProgressCard value={response?.relevancy}
                        total={response?.totalScore || 160}
                        color={"#6703fe"}
                        suggestions={response?.relevancySuggestions || []}
                        title={"Task relevance"} />

                </div>
            </div>


            <div className={"w-full border-b-[1px] opacity-10 my-2 border-black"} />

            <HeadingBlog title={"AI Recognition"} paragraph={response?.aiRecognition} />
            <HeadingBlog title={"AI Assessment"} paragraph={response?.aiAssessment} />
            <HeadingBlog title={"AI Proofreading"} paragraph={response?.aiProofreading} />

            {
                response?.correctnessPercentage !== undefined && <div className={"flex flex-col gap-3 "}>
                    <h1 className={"text-xl font-bold  text-gray-700  "}>Correctness Percentage</h1>
                    <p className={"text-base font-normal  text-gray-700  "}>
                        {Math.round(response?.correctnessPercentage)}%
                    </p>
                </div>
            }

            <CorrectSelected correctSelected={response?.correctSelected} correct={response?.correct} />


            <WordGrading wordsGrade={response?.wordsGrade} />

            <AiSuggestion suggestions={response?.suggestions} />


            <div className={"flex flex-col gap-4"}>
                {
                    response?.grammarErrors?.map((error, index) => {

                        return (
                            <AnswerDropDown
                                key={index}
                                // headerTitle={error?.ruleId.replace("_", " ")}
                                headerTitle={""}
                                headerSubTitle={error?.message}
                                possibleAnswers={error?.replacements?.join(", ")}
                                justifications={error?.context}
                            />
                        )
                    })
                }

            </div>

            {

                response?.cefrLevel && <>
                    <h1 className={"text-xl font-bold  text-gray-700  "}>CEFR Level</h1>
                    <SentenceCefr
                        data={response?.cefrLevel?.occurance}
                        sentence={response?.cefrLevel?.sequence}
                    />
                </>
            }

            <HeadingBlog title={"AI Rewriting"} paragraph={response?.aiRewriting} />


            {
                response?.answerUrl &&
                <AnswerEmptyDropDown
                    className={" mt-4 "}
                    headerTitle={"Show Answer"}
                >

                    <audio
                        className={"bg-white rounded-full"} controls src={response?.answerUrl} />
                </AnswerEmptyDropDown>


            }

        </div>
    </BaseModal>

    )
}